import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { defaultImage, Image, PostImage, PutImage } from 'src/app/interfaces/api/image';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';
import { LocalStorageService } from '../../core/local-storage.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class ImageService {

  collection = "Image";
  collectionPath = "images";
  images: Image[] = [];
  apiUrl = environment.API_URL;
  currentProject: BehaviorSubject<Image> = new BehaviorSubject<Image>(defaultImage);

  constructor(
    private apiService: ApiService,
    private localStorage: LocalStorageService
  ) {
  }

  //---GET---//

  getImages(query: QueryParams): Observable<Image[]> {
    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  getImagesByStatus(query: QueryParams): Observable<Image[]> {
    return this.apiService.getCollection(this.collectionPath, "byImageStatus", query);
  }

  getImagesByLoadedStatus(query: QueryParams): Observable<{ images: Image[], alreadyViewed: boolean }> {
    return this.apiService.getCollection(this.collectionPath, "byLoadedStatus", query);
  }

  getImageWithFilter(query: QueryParams): Observable<Image[]> {
    return this.apiService.getCollection(this.collectionPath, "filter", query);
  }

  getImageById(id: string, key: string | null = null): Observable<Image> {
    return this.apiService.getCollectionItem(this.collectionPath, "", id);
  }

  searchImages(search: string, query: QueryParams = {}): Observable<Image[]> {
    return this.apiService.getCollection(this.collectionPath, 'search', { q: search, ...query });
  }

  getImagesCount(search: string = "", query: QueryParams): Observable<number> {
    return this.apiService.getCollection(this.collectionPath, 'count', { q: search, ...query });
  }

  //---POST---//

  addImage(image: PostImage): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, "", image);
  }

  //---PUT---//

  setImage(image: PutImage): Observable<any> {
    return this.apiService.updateCollection(this.collectionPath, "", image);
  }

  //---DELETE---//

  deleteImage(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }

  deleteImages(query: QueryParams): Observable<any> {
    return this.apiService.deleteCollectionItems(this.collectionPath, query);
  }

  //---OTHER---//

  public get currentProjectValue(): Image | null {
    return this.currentProject.value;
  }

  setCurrentImages(images: Image) {
    this.localStorage.setItem('images', images);
    this.currentProject.next(images);
  }
}
